import { render } from "./MW2023NewsList.vue?vue&type=template&id=27d45861"
import script from "./MW2023NewsList.vue?vue&type=script&lang=js"
export * from "./MW2023NewsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__